import React, { useState, VFC } from 'react';
import { Container, Row, Col, Visible } from 'react-grid-system';
import styled from 'styled-components';
import Spacing from '../components/atoms/Spacing';
import Typography from '../components/atoms/Typography';
import { useReturnContext } from '../contexts/returnContext';
import TableItem from '../components/molecules/TableItem';
import { useSettings } from '../contexts/settingsContext';
import FreightBookingForm from '../components/organisms/form/FreightBookingForm';
import Banner from '../components/molecules/Banner';

interface Props {
  radius?: string;
}

const Border = styled(Container)<Props>`
  border-radius: ${({ radius }) => radius};
  border: 1px solid #e0e0e0;
`;

const Section = styled(Row)`
  border-bottom: 1px solid #e0e0e0;
  padding: 3.2rem 0px;
`;

const FreightImage = styled.img`
  max-width: 32px;
  object-fit: contain;
  aspect-ratio: 3/4;
  padding-right: 0.8rem;
`;

const ReturnFreightSummaryPage: VFC = () => {
  const { returns, selectedCarrier } = useReturnContext();
  const [postReturnError, setPostReturnError] = useState<boolean>(false);
  const { cornerRadius } = useSettings();

  const table = [
    {
      key: 'service',
      title: <Typography translateKey="carrier" variant="body1-semi-bold" />,
      value: selectedCarrier.carrier,
    },
    {
      key: 'type_of_parcel',
      title: (
        <Typography translateKey="carrier_service" variant="body1-semi-bold" />
      ),
      value: selectedCarrier.service,
    },
    {
      key: 'no_of_parcels',
      title: (
        <Typography translateKey="no_of_parcels" variant="body1-semi-bold" />
      ),
      value: selectedCarrier.numberOfParcels,
    },
  ];

  const numberOfProducts = Object.values(returns).reduce(
    (prev, current) => prev + current.returnData.amount,
    0,
  );

  return (
    <Border radius={cornerRadius}>
      <Section justify="center">
        <Typography translateKey="summary" variant="h3" />
      </Section>
      {postReturnError && (
        <>
          <Spacing spacing={4} />
          <Banner variant="error" message="registration_failed" />
        </>
      )}
      <Section>
        <Col xs="content">
          <Typography translateKey="no_of_products" variant="body1-semi-bold" />
          <Typography variant="h3">{numberOfProducts}</Typography>
          <Spacing spacing={2} />
          <Row gutterWidth={8}>
            <Col xs={12} sm="content">
              <FreightImage src={selectedCarrier.logoUrl} />
            </Col>
            {table?.map((item) => (
              <Col key={item.key} xs={12} sm="content">
                <TableItem title={item.title} value={item.value} />
                <Visible xs>
                  <Spacing spacing={1} />
                </Visible>
              </Col>
            ))}
          </Row>
        </Col>
      </Section>
      <Spacing spacing={4} />
      <FreightBookingForm setPostReturnError={setPostReturnError} />
    </Border>
  );
};

export default ReturnFreightSummaryPage;
